import {
  HeaderType,
  HomeButton,
  HomeLayout,
  Site,
  SiteDocument,
  SponsorStyleOptions,
} from "@/types/site.ts";
import { transformMedia } from "@/util/mediaHelper.v2.ts";

export default function mapDocToSite(doc: SiteDocument): Site {
  return {
    ...doc,
    headerType: doc.headerType as HeaderType,
    announcements: (doc.announcements ?? []).map(transformMedia),
    backgroundImage: (doc.backgroundImage ?? []).map(transformMedia),
    customFonts: (doc.customFonts ?? []).map(transformMedia),
    genericImage: (doc.genericImage ?? []).map(transformMedia),
    homeButtons: doc.homeButtons as HomeButton[],
    media: (doc.media ?? []).map(transformMedia),
    presentingSponsorImages: (doc.presentingSponsorImages ?? []).map(
      transformMedia
    ),
    primaryLogo: (doc.primaryLogo ?? []).map(transformMedia),
    sponsorImages: (doc.sponsorImages ?? []).map(transformMedia),
    layout: doc.layout as HomeLayout,
    sponsorStyle: doc.sponsorStyle as SponsorStyleOptions,
  };
}
